import { render, staticRenderFns } from "./GruposDisponiblesPage.vue?vue&type=template&id=4bf2858b&scoped=true&"
import script from "./GruposDisponiblesPage.vue?vue&type=script&lang=js&"
export * from "./GruposDisponiblesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf2858b",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/inscripciones/GruposDisponiblesPage.vue
// module id = 222
// module chunks = 24